/**
 * ProvenanceBadge — small pill showing where a row came from.
 *
 * Rules match ADR-007:
 *   * `founder_explicit` / `founder_preference` (no source_session_id):
 *       "Manual" pill (neutral).
 *   * Anything with source_session_id: "Voice" pill (cyan) linking to
 *       /conversations/{session_id}.
 */
import { MessagesSquare, Hand } from "lucide-react";
import { Link } from "react-router-dom";

export default function ProvenanceBadge({ sourceType, sourceSessionId }) {
    if (sourceSessionId) {
        return (
            <Link
                to={`/conversations/${sourceSessionId}`}
                data-testid="provenance-voice"
                className="inline-flex items-center gap-1.5 rounded-full px-1.5 py-0.5 font-mono-ui text-[8px] tracking-widest uppercase text-qoryn-cyan bg-qoryn-cyan/10 hover:bg-qoryn-cyan/20 transition-colors"
            >
                <MessagesSquare className="h-2.5 w-2.5" strokeWidth={2} />
                Voice · {sourceType}
            </Link>
        );
    }
    return (
        <span
            data-testid="provenance-manual"
            className="inline-flex items-center gap-1.5 rounded-full px-1.5 py-0.5 font-mono-ui text-[8px] tracking-widest uppercase text-qoryn-textDim bg-white/5"
        >
            <Hand className="h-2.5 w-2.5" strokeWidth={2} />
            Manual
        </span>
    );
}
